import { render, staticRenderFns } from "./TogglePublic.vue?vue&type=template&id=25b270e2&scoped=true&"
import script from "./TogglePublic.vue?vue&type=script&lang=js&"
export * from "./TogglePublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b270e2",
  null
  
)

export default component.exports